<template>
  <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <!-- <div class="bg"><div></div></div> -->
  <MainMenu 
    @click-button="uslugi=0"
    @click-button-consult="handleEventClickButtonConsult"
  />
  <div class="content">
    <FirstBlock 
      :showTime="!uslugi"
      @click-button-consult="handleEventClickButtonConsult"
      ></FirstBlock>
      <template v-if="!uslugi">
        <VideoBlock/>
        <PhotoBlock/>
      </template>
      <TransitionGroup>
      <template v-if="!uslugi">
      <WhoListeners></WhoListeners>
      <UchastnikBlock></UchastnikBlock>
      <div class="container uslugi-wrap">
        <h2>Если у Вас есть вопросы и нужна консультация</h2>
        <button @click="handleClickButtonUslugi">Обратиться к спикерам</button>
      </div>
      <TariffBlock></TariffBlock>
      <ScheduleBlock></ScheduleBlock>
      <LocationBlock></LocationBlock>
      <PartnersBlock>
        <SponsorForm :sendResult="sendResult" @return-data="handleEventReturnData"></SponsorForm>
      </PartnersBlock>
    </template>
    <template v-else>
      <UslugiBlock :sendResult="sendResult" @return-data="handleEventReturnData"></UslugiBlock>
    </template>
    </TransitionGroup>
    <FooterBlock>
      <ZapisBlock :sendResult="sendResult" @return-data="handleEventReturnData"></ZapisBlock>
    </FooterBlock>
  </div>
</template>

<script>
import axios from 'axios'
// import HelloWorld from './components/HelloWorld.vue'
import MainMenu from './components/MainMenu'
import FirstBlock from '@/components/FirstBlock'
import UchastnikBlock from '@/components/UchastnikBlock'
import WhoListeners from '@/components/WhoListeners'
import ScheduleBlock from './components/ScheduleBlock'
import LocationBlock from './components/LocationBlock'
// import OrganizatorBlock from '@/components/OrganizatorBlock'
import PartnersBlock from '@/components/PartnersBlock'
import ZapisBlock from '@/components/ZapisBlock'
import FooterBlock from '@/components/FooterBlock'
import TariffBlock from './components/TariffBlock'
import SponsorForm from './components/SponsorForm.vue'
import UslugiBlock from './components/UslugiBlock.vue'
import VideoBlock from './components/VideoBlock.vue'
import PhotoBlock from './components/PhotoBlock.vue'

import { getParam } from '@/lib/getParam';

export default {
  name: 'App',
  components: {
    MainMenu, 
    FirstBlock,
    WhoListeners,
    UchastnikBlock,
    TariffBlock,
    ScheduleBlock,
    LocationBlock,
    // OrganizatorBlock,
    PartnersBlock,
    ZapisBlock,
    SponsorForm,
    FooterBlock,
    UslugiBlock,
    VideoBlock,
    PhotoBlock,
  },
  data(){
    return{
      sendResult: {},
      uslugi: false,
      devel: false,
    }
  },
  mounted() {
    this.devel = getParam('devel') ? true : false
  },
  methods: {
    handleClickButtonUslugi: function() {
      this.uslugi = 1
      // this.devel = 1
      // document.querySelector('.container .uslugi').scrollIntoView('top')
    },
    handleEventReturnData: function(data) {
      // console.log('app handleEventReturnData', data )
      this.sendMessage( data )
    },
    sendMessage: async function(data) {
      this.sendResult = await axios.post( '/mailer', 
        {
          form: data.form,
          name: data.name,
          email: data.email,
          tel: data.tel,
          comp: data.comp,
          text: data.text,
          komu: data.komu,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      )
    },
    handleEventClickButtonConsult: function() {
      // console.log('handleEventClickButtonConsult')
      this.uslugi = 1
    },
  },
  watch: {
    // devel: function(value) {
    //   if (value) {
    //     // document.querySelector('.uslugi-card-wrap').scrollIntoView('top')
    //     document.body.scrollIntoView({
    //       behavior: 'smooth',
    //       // block: 'top',
    //     })
    //   }
    // }
  }
}
</script>

<style lang="scss">
// @import url('https://fonts.googleapis.com/css2?family=Play:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
$background: #290a4f;
body{
  margin: 0;
}
#app {
  font-family: "Play", sans-serif;
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  /* -webkit-font-smoothing: antialiased; */
  /* -moz-osx-font-smoothing: grayscale; */
  text-align: center;
  // color: #290A4F;
  /* margin-top: 60px; */
  background-color: $background;
  // background-image: url('assets/bg.jpg');
  // background-position: center;
  // background-size: cover;
  // background-repeat: no-repeat;
  // background-attachment: fixed;
  // h1{
  //   color: #fff;
  //   font-weight: 700;
  //   text-transform: uppercase;
  // }
  h1,h2,h3{
    color: #fff;
    font-weight: 700;
    text-align: left;
    text-transform: uppercase;
  }
  .uslugi-wrap{
    button{
        border: none;
        height: 40px;
        border-radius: 15px;
        background: #1E9BD8;
        color: #fff;
        text-transform: uppercase;
        line-height: 0;
        // font-weight: 700;
        font-size: 1em;
        padding: 10px 24px;
        cursor: pointer;
        transition: .4s;
        &:hover{
            transition: .4s;
            color: #1E9BD8;
            background: #fff;
        }
    }
  }
  &>.content>div>h2{
    padding-left: 10px;
    @media ( min-width: 576px ) {
      padding-left: 0px;
    }
  }
  &>.content{
    $color1: #675193;
    $color2: #3F296B;
    $color3: #2128A5;
    $color4: #0B0557;
    background-image: 
      radial-gradient( circle at 8% 74%, $color1 -20%, transparent 26% ), 
      radial-gradient( circle at 25% 43%, $color2 -10%, transparent 23%),
      radial-gradient( circle at 45% 43%, $color3 -10%, transparent 23%),
      radial-gradient( circle at 80% 43%, $color4 -10%, transparent 23%),
  }
  .container{
    margin-left: auto;
    margin-right: auto;
    max-width: calc( 100% - 4px );
    @media ( min-width: 576px ) {
      max-width: 540px;
    }
    @media ( min-width: 768px ) {
      max-width: 720px;
    }
    @media ( min-width: 992px ) {
      max-width: 960px;
    }
    @media ( min-width: 1200px ) {
      max-width: 1140px;
    }
    @media ( min-width: 1400px ) {
      max-width: 1340px;
    }
  }
}
ul,ol{
  li{
    color: #fff;
    margin-bottom: .25em;
    &.plus{
      list-style: none;
      margin-bottom: .0em;
      &::before{
        content: '';
        display: block;
        position: relative;
        top: 14px;
        left: -22px;
        background-image: url('@/assets/plus.svg');
        background-size: cover;
        width: 10px;
        height: 10px;
      }
    }
  }
}
// .indevel{
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   z-index: 5;
//   &>div{
//     width: 80%;
//     // display: flex;
//     // justify-content: center;
//     border: outset 1px rgb(255, 255, 255);
//     border-radius: 10px;
//     color: rgb(255, 255, 255);
//     // transform: rotate( 5deg );
//     padding: 25px;
//     margin: 2em auto 0 auto;
//     font-size: 1.5em;
//     text-transform: uppercase;
//   }
// }
.v-enter-active,
.v-leave-active {
  transition: opacity .2s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
